module.exports = __webpack_public_path__ + "fonts/ab32396.eot";